import httpClient from '@/http-client'

export const get = (Options = {}) => {
	return httpClient
		.get("/api/v1/repair-products", Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
	return httpClient
		.get(`/api/v1/repair-products/${id}`, Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const store = data => {
	return httpClient
		.post('/api/v1/repair-products', data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const diagnosticRepairProduct = (id, data) => {
	return httpClient
		.put(`/api/v1/repair-products/${id}`, data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const updateRepairStatus = (id, data) => {
	return httpClient
		.put(`/api/v1/repair-products/update-repair-status/${id}`, data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
	return httpClient
		.delete(`/api/v1/repair-products/${id}`)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
	return httpClient
		.get(`/api/v1/repair-products/form-view-models`, Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export default {
	get,
	find,
	store,
	updateRepairStatus,
	diagnosticRepairProduct,
	destroy,
	formViewModel,
}